import React from 'react';
import { MessageSquare, Users, Clock, BrainCircuit } from 'lucide-react';

/**
 * MetricsCards — Four at-a-glance summary cards.
 * Low cognitive load: just the number + label, no extra noise.
 */
export default function MetricsCards({ data }) {
    if (!data) return null;

    const formatNumber = (n) => {
        if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
        return String(n);
    };

    const formatTime = (seconds) => {
        if (!seconds || seconds === 0) return '—';
        if (seconds < 60) return `${Math.round(seconds)}s`;
        if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
        return `${(seconds / 3600).toFixed(1)}h`;
    };

    const cards = [
        {
            icon: <MessageSquare size={20} />,
            color: 'blue',
            value: formatNumber(data.total_messages || 0),
            label: 'Total Messages',
        },
        {
            icon: <Users size={20} />,
            color: 'green',
            value: formatNumber(data.active_customers || 0),
            label: 'Active Customers',
        },
        {
            icon: <Clock size={20} />,
            color: 'indigo',
            value: formatTime(data.avg_response_time_seconds),
            label: 'Avg Response Time',
        },
        {
            icon: <BrainCircuit size={20} />,
            color: 'amber',
            value: `${data.ai_response_rate || 0}%`,
            label: 'AI Response Rate',
        },
    ];

    return (
        <div className="metrics-grid">
            {cards.map((card, i) => (
                <div className="metric-card" key={i}>
                    <div className={`metric-card__icon ${card.color}`}>
                        {card.icon}
                    </div>
                    <div className="metric-card__value">{card.value}</div>
                    <div className="metric-card__label">{card.label}</div>
                </div>
            ))}
        </div>
    );
}
